import { EType, IPaidPublicationState } from './types';

export const defaultState: IPaidPublicationState = {
  days: 0,
  autoProlong: false,
  highDemandCoefficient: 0,
  isPaid: false,
  restriction: {
    isAllowed: true,
    restrictionType: undefined,
  },
  price: 0,
  token: '',
  initial: true,
  tariffIdentificator: undefined,
  type: EType.DailyLimited,
};
